import React from 'react'
import { useHistory } from 'react-router'
import { Button, Typography, useDimensions } from '@telavita-core/react-design-kit'

import { DASHBOARD_HOME_PATIENT } from 'settings/_routesSettings'
import { useScrollToTop } from 'hooks/useScrollToTop'

import { ReactComponent as CheckIcon } from 'static/svg/green-check.svg'

import * as S from './styles'

export const NpsReviewCompleted = () => {
  useScrollToTop()
  const { isMobile } = useDimensions()
  const history = useHistory()

  return (
    <S.Container isMobile={isMobile}>
      <S.Content>
        <CheckIcon />
        <Typography variant='header4' weight='bold'>
          Agradecemos a sua avaliação!
        </Typography>
        <Button 
          onClick={() => history.push(DASHBOARD_HOME_PATIENT)}
          variant='contained' 
          uppercase={false}
        >
          Ir para a página inicial
        </Button>
      </S.Content>
    </S.Container>
  )
}